@use '~/theme/theme' as *;

.actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
}

.title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: color(violet-100);
  padding-bottom: spacing(2);
}

.content {
  gap: spacing(3);
  padding-top: spacing(2);
}

.actionsContainer {
  display: flex;
  justify-content: flex-end;
  gap: spacing(2);
}

.xmlPreviewContent {
  padding: spacing(4);
  margin: spacing(-2);
  background: white;
}

.hidden {
  display: none;
}
